"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateLegApiErrorCode = void 0;
exports.UpdateLegApiErrorCode = {
    INVALID_ORDER_STATUS_TRANSITION: 'INVALID_ORDER_STATUS_TRANSITION',
    UPDATE_FAILURE: 'UPDATE_FAILURE'
};
//# sourceMappingURL=update-leg-api-error-code.js.map